<template>
    <div class='nav'>
        <div @click='goRout(0)'><span class='span span0' :class='navIndex==0?"checked-span0":""'><i v-if='messageCount!=0&&messageCount!="undefined"'>{{messageCount}}</i></span><span :class='navIndex==0?"checked":""'>待处理</span></div>
        <div @click='goRout(1)'><span class='span span1' :class='navIndex==1?"checked-span1":""'><i v-if='messageCount2!=0&&messageCount2!="undefined"'>{{messageCount2}}</i></span><span :class='navIndex==1?"checked":""'>抄送我</span></div>
        <div @click='goRout(2)'><span class='span span2' :class='navIndex==2?"checked-span2":""'></span><span :class='navIndex==2?"checked":""'>我的</span></div>
    </div>
</template>
<script>
import * as Urls from '../../helper/Urls';
import * as VueHelper from '../../helper/VueHelper';
import {Dialog,Toast} from 'vant';
export default {
    props:{
        navIndex:{
            type:Number,
            default:0,
        }
    },
    data(){
        return{
            messageIntval:null,
            messageCount:0,
            messageCount2:0
        }
    },
    components:{
        Toast
    },
    created(){
        this.messageCount = sessionStorage.getItem('messageCount')?sessionStorage.getItem('messageCount'):0
        this.messageCount2 = sessionStorage.getItem('messageCount2')?sessionStorage.getItem('messageCount2'):0
        this.getUnreadCount();
        this.getUnreadCopyCount();
        this.messageIntval = setInterval(()=>{
            this.getUnreadCount();
            this.getUnreadCopyCount();
        },1000*10)
    },
    methods:{
        goRout(navIndex){
            switch(navIndex){
                case 0: this.$router.push('/appLogin/agent');break
                case 1: this.$router.push('/appLogin/copy');break
                case 2: this.$router.push('/appLogin/appUserInfo');break
            }
        },
        //获取待办未读消息数量
        getUnreadCount(){
            let inst = this;
            let url = Urls.message_unreadMsgCount;
            inst.$root.doPost(url,{},function(server_data) {
                inst.messageCount = server_data.data>99?'99+':server_data.data;
                sessionStorage.setItem('messageCount',inst.messageCount)
            },null,1)
        },
        //获取抄送未读消息数量
        getUnreadCopyCount(){
            let inst = this;
            let url = Urls.message_unreadCopyMsgCount;
            inst.$root.doPost(url,{isAwait:'Y'},function(server_data) {
                inst.messageCount2 = server_data.data>99?'99+':server_data.data;
                sessionStorage.setItem('messageCount2',inst.messageCount2)
            },null,1)
        },
    },
    destroyed(){
        clearInterval(this.messageIntval);
    }
}
</script>
<style lang="scss" scoped>
    $url:'https://xmyun.zhoty.com/resource/xmwebapp/';
    .nav{
        height: .83rem;
        background:#fff;
        display: flex;
        justify-content: space-around;
        position: fixed;
        max-width: 750px;
        width: 100%;
        bottom: 0;
        font-size: .11rem;
        div{
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .checked{
            color:#EC1212;
            font-weight: bold;
        }
        .span{
            height: .2rem;
            width:.18rem;
            margin:.1rem 0 .06rem;
            position: relative;
            i{
                display: flex;
                font-style: normal;
                position: absolute;
                color:#fff;
                background: #EC1212;
                width: .28rem;
                min-height: .15rem;
                justify-content: center;
                align-items: center;
                border-radius: .08rem;
                font-size: .12rem;
                top:-.08rem;
                right:-.28rem;
            }
        }
        .span0{
            background: url($url+'pending-handle-unchecked.png') no-repeat;
            background-size:contain;
            background-position: right;
        }
        .span1{
            background: url($url+'copy-tome-unchecked.png') no-repeat;
            background-size:contain;
        }
        .span2{
            background: url($url+'user-info-unchecked.png') no-repeat;
            background-size:contain;
        }
        .checked-span0{
            background: url($url+'pending-handle-checked.png') no-repeat;
            background-size:contain;
            background-position: right;
        }
        .checked-span1{
            background: url($url+'copy-tome-checked.png') no-repeat;
            background-size:contain;
        }
        .checked-span2{
            background: url($url+'user-info-checked.png') no-repeat;
            background-size:contain;
        }
    }
</style>


// WEBPACK FOOTER //
// appNav.vue?619f3d04